import React from 'react';
import { ArrowLeft, BookOpen, Bot, FileCheck2, Network, PhoneCall } from 'lucide-react';
import { SITE_LINKS } from '../lib/siteLinks';

interface Props {
  active: 'arborai' | 'worksheetz' | 'arborlink' | 'vox' | 'education';
  onNavigate: (view: string) => void;
}

const tools = [
  { id: 'vox', icon: PhoneCall, label: 'Vox' },
  { id: 'education', icon: BookOpen, label: 'Education' },
  { id: 'arborai', icon: Bot, label: 'ArborAI' },
  { id: 'worksheetz', icon: FileCheck2, label: 'Worksheetz' },
  { id: 'arborlink', icon: Network, label: 'ArborLink' },
] as const;

/**
 * Shared footer navigation connecting the public tools.
 * Every public page gets links to the others plus Home — no dead ends.
 */
const PublicToolNav: React.FC<Props> = ({ active, onNavigate }) => {
  return (
    <footer className="bg-bark text-white">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 py-8">
        <p className="text-center text-[10px] sm:text-xs font-black uppercase tracking-widest text-stone-400 mb-4">
          Explore the GreenTree Toolbox
        </p>
        <div className="flex flex-wrap items-center justify-center gap-2 sm:gap-3">
          {tools.map(tool => (
            <button
              key={tool.id}
              onClick={() => onNavigate(tool.id)}
              disabled={tool.id === active}
              className={`inline-flex items-center gap-1.5 px-4 py-2 rounded-xl text-xs sm:text-sm font-bold transition ${
                tool.id === active
                  ? 'bg-stone-700 text-stone-300 cursor-default'
                  : 'bg-stone-600 hover:bg-stone-500 text-white'
              }`}
            >
              <tool.icon className="w-4 h-4" />
              {tool.label}
              {tool.id === active ? ' (you are here)' : ''}
            </button>
          ))}
        </div>
        <div className="mt-6 pt-5 border-t border-stone-700 flex flex-col sm:flex-row items-center justify-between gap-3 text-[11px] text-stone-400">
          <button
            onClick={() => onNavigate('landing')}
            className="inline-flex items-center gap-1.5 hover:text-white transition font-bold"
          >
            <ArrowLeft className="w-3.5 h-3.5" /> greentreearboriculture.com
          </button>
          <div className="flex items-center gap-4">
            <a href={SITE_LINKS.youtube} target="_blank" rel="noreferrer" className="hover:text-white transition">YouTube</a>
            <a href={SITE_LINKS.tiktok} target="_blank" rel="noreferrer" className="hover:text-white transition">TikTok</a>
            <a href="/privacy.html" className="hover:text-white transition">Privacy</a>
            <a href="/terms.html" className="hover:text-white transition">Terms</a>
            <a href="/accessibility.html" className="hover:text-white transition">Accessibility</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default PublicToolNav;
